import React, { Fragment, Component } from "react";
import TableHolder from "./section1/tableHolder";
import BoxGridHolder from "./section2/boxGridHolder";

class RiskStatistic extends Component {
  state = {
    risk_table_columns: [],
    risk_table_rows: [],
  };
  componentDidMount() {
    this.setState({
      risk_table_columns: this.props.risk_table_columns,
      risk_table_rows: this.props.risk_table_rows,
    });
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      risk_table_columns: nextProps.risk_table_columns,
      risk_table_rows: nextProps.risk_table_rows,
    });
  }
  render() {
    const {
      getRiskStatistics,
      display_orig_portfolio,
      benchmark_name,
      model_name,
    } = this.props;
    const { risk_table_columns, risk_table_rows } = this.state;
    return (
      <div className="row">
        <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <h4 className="text-uppercase bold">Risk statistics</h4>
          <Fragment>
            {risk_table_columns.length ? (
              <TableHolder
                risk_table_columns={risk_table_columns}
                risk_table_rows={risk_table_rows}
                benchmark_name={benchmark_name}
                display_orig_portfolio={display_orig_portfolio}
                model_name={model_name}
              />
            ) : null}
          </Fragment>
        </div>
        {getRiskStatistics.length ? (
          <BoxGridHolder getRiskStatistics={getRiskStatistics} />
        ) : null}
      </div>
    );
  }
}

export default RiskStatistic;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/statistics/RiskStatistic/RiskStatistic.jsx